import { useBreakpoint } from '$hooks/events';
import { Image } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings').ArticleItem}
 */
const Article = ({
    author,
    categories,
    title,
    listingImage,
    url,
    _isLargeCol
}) => {
    const breakpoint = useBreakpoint([ 'main', 'sm', 'md' ], 'main');
    const height = _isLargeCol ? '450px' : '350px';

    return (
        <div className='expand-interaction-container height-100'>
            <a
                className='link-reset expand-interaction__action'
                href={url}>
                <div
                    className={`flex flex-col bg-white px5 md-px6 pt5 pb6 md-pt8 md-pb9 grey${_isLargeCol ? ' sticky top-0' : ''}`}
                    style={{fontSize: height}}>
                    <div className='flex flex-wrap'>
                        {categories.map((category, idx) => {
                            return (
                                <p
                                    className='type-style-5 black inline mr2'
                                    key={category?.id}>
                                    {category?.label}
                                    {categories?.length > 1 && idx !== categories?.length -1 ? ', ' : ''}
                                </p>
                            );
                        })}
                        <h3 className='type-style-3 sans-serif black width-100'>
                            {title}
                        </h3>
                    </div>
                    <div
                        className='mt-auto pt5'>
                        {listingImage && (
                            <div style={{
                                height: breakpoint === 'md' ? height : 'auto',
                                width: breakpoint === 'md' ?`${(listingImage?.width / listingImage?.height)}em` : '280px',
                                maxWidth: '100%'
                            }}>
                                <Image {...listingImage}/>
                            </div>
                        )}
                        {(author) && (
                            <div className='mt5 md-mt4 flex'>
                                <p className='type-style-5 black inline'>{`Words by ${author}`}</p>
                            </div>
                        )}
                    </div>
                </div>

            </a>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Article.__typename = 'ArticlePage';

export default Article;
